import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../mock';

const LandingPageFooter = () => {
  return (
    <footer className="bg-[#000000] py-12 sm:py-16 border-t border-[#302f2c]">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          {/* Company Logo - Updated to logo-02.png */}
          <div>
            <div className="flex justify-center mb-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_publishhub/artifacts/bqttbt7x_logo-02.png"
                alt="White House Publishers"
                className="h-12 sm:h-14 w-auto"
              />
            </div>
            <p className="text-[#dfddd6] text-sm sm:text-base max-w-2xl mx-auto leading-relaxed">
              White House Publishers transforms manuscripts into literary masterpieces, combining expertise and artistry to create captivating books that achieve success.
            </p>
          </div>

          {/* Contact Information */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-sm sm:text-base">
            <a href={`tel:${companyInfo.phone}`} className="flex items-center gap-2 text-[#888680] hover:text-[#F4D03F] transition-colors">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
              {companyInfo.phone}
            </a>
            <span className="text-[#888680] hidden sm:inline">|</span>
            <a href="mailto:info@whitehousepublishers.com" className="flex items-center gap-2 text-[#888680] hover:text-[#F4D03F] transition-colors">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              info@whitehousepublishers.com
            </a>
          </div>

          {/* Legal Links */}
          <div className="flex items-center justify-center gap-3 sm:gap-4 text-sm sm:text-base">
            <Link 
              to="/privacy-policy" 
              className="text-[#888680] hover:text-[#F4D03F] transition-colors"
            >
              Privacy Policy
            </Link>
            <span className="text-[#888680]">|</span>
            <Link 
              to="/terms-conditions" 
              className="text-[#888680] hover:text-[#F4D03F] transition-colors"
            >
              Terms & Conditions
            </Link>
          </div>

          {/* Copyright */}
          <div>
            <p className="text-[#888680] text-xs sm:text-sm">
              Copyright © 2025 {companyInfo.name}. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingPageFooter;